import { useState } from "react";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
// import { Link } from "react-router-dom";
// import AlertBox from "../../components/AlertBox";
import Pagination from "../../components/Pagination";
import { useAddonStats } from "../../utils/addons/AddonUtils";
import moment from "moment";
import ModalDetailLogAddons from "../../components/customer/addons/ModalDetailLogAddons";

export default function StatsAddonPage() {
  // Set default dates to current month
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

  const [modal, setModal] = useState(null);
  const [selected, setSelected] = useState(null);

  const [filter, setFilter] = useState({
    start_date: startOfMonth,
    end_date: endOfMonth,
    page: 1,
    page_size: 30,
  });
  const [formFilter, setFormFilter] = useState({
    start_date: startOfMonth,
    end_date: endOfMonth,
  });

  const { statistics, meta, loading } = useAddonStats({ filter });

  // Date validation function
  function validateDateRange(startDate, endDate) {
    if (startDate && endDate) {
      return moment(startDate).isSameOrBefore(moment(endDate));
    }
    return true;
  }

  // Handle start date change with validation
  function handleStartDateChange(newStartDate) {
    const updatedFilter = { ...formFilter, start_date: newStartDate };

    // If end date exists and new start date is after end date, adjust end date
    if (formFilter.end_date && moment(newStartDate).isAfter(moment(formFilter.end_date))) {
      updatedFilter.end_date = newStartDate;
    }

    setFormFilter(updatedFilter);
  }

  // Handle end date change with validation
  function handleEndDateChange(newEndDate) {
    // Only update if end date is not before start date
    if (validateDateRange(formFilter.start_date, newEndDate)) {
      setFormFilter({ ...formFilter, end_date: newEndDate });
    }
  }

  function applyFilter() {
    let form_filter = {
      ...filter,
      ...formFilter,
      page: 1,
    };
    setFilter(form_filter);
  }

  const resetFilter = () => {
    setFormFilter({
      start_date: startOfMonth,
      end_date: endOfMonth,
    });
    setFilter({
      start_date: startOfMonth,
      end_date: endOfMonth,
      page: 1,
      page_size: 30,
    });
  };

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  return (
    <MainLayout resource_key="customer">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Statistik Akses Add-on</h1>
          </div>
          {/* <div className="col-auto">
            <button className="btn btn-primary">
              <i className="fa fa-download"></i> Unduh Report
            </button>
          </div> */}
        </div>
        <div className="row">
          <div className="col-12">
            <Box title="Statistik Akses Addons" loading={loading}>
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <label>Tanggal Mulai</label>
                    <input
                      type="date"
                      className="form-control"
                      value={formFilter.start_date}
                      onChange={(event) => handleStartDateChange(event.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label>Tanggal Akhir</label>
                    <input
                      type="date"
                      className="form-control"
                      value={formFilter.end_date}
                      min={formFilter.start_date}
                      onChange={(event) => handleEndDateChange(event.target.value)}
                    />
                  </div>
                </div>
                <div className="col-auto">
                  <button
                    className="btn btn-primary"
                    onClick={() => applyFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Filter
                  </button>
                  <button
                    className="btn btn-default"
                    onClick={() => resetFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Reset
                  </button>
                </div>
              </div>
              <table className="table table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th>Tanggal</th>
                    <th>Jumlah Akses</th>
                  </tr>
                </thead>
                <tbody>
                  {statistics.length === 0 && (
                    <tr>
                      <td colSpan={3} className="text-center">
                        Tidak ada data
                      </td>
                    </tr>
                  )}
                  {statistics.map((stat, index) => (
                    <tr key={index}>
                      <td style={{ width: "100px" }}>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => {
                            setModal("detail-addons");
                            setSelected(stat.date);
                          }}
                        >
                          <i className="fa fa-eye"></i>
                        </button>
                      </td>
                      <td>{moment(stat.date).format("DD MMM YYYY")}</td>
                      <td>{stat.total}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {meta.count > meta.page_size && (
                <Pagination
                  totalpage={Math.ceil(meta.count / meta.page_size)}
                  selectedpage={meta.page}
                  clickpage={(page) => gotoPage(page)}
                  next={() => gotoPage(meta.page + 1)}
                  prev={() => gotoPage(meta.page - 1)}
                />
              )}
            </Box>
          </div>
        </div>
      </div>

      <ModalDetailLogAddons
        show={modal === "detail-addons"}
        date={selected}
        onClose={() => setModal(null)}
      />
    </MainLayout>
  );
}
